import { Component, OnInit, Input } from '@angular/core';

/*
 * This component displays as 7 bubbles with text which summarize the number of stations at each status: no report, not in service, and
 * 5 novascores.  It expects 1 array input:
 *  <app-visual-totals [points]="stageCounts"></app-visual-totals> 
 * where points is defined as:
 * points = [
			{
				rect: {x: "5", stroke: "black", fill: "black"},
				text: {x: "7", stroke: "white", count: noReportCount}
      }, ... repeated 6 times for no service and 5 novascore counts.  Note the the x needs to increase since this is the x location of the bubble.
    ]
*/

@Component({
  selector: 'app-visual-totals',
  standalone: false,
  templateUrl: './visual-totals.component.html',
  styleUrls: ['./visual-totals.component.css']
})
export class VisualTotalsComponent implements OnInit {
  @Input() points: any[];

  constructor() { }

  ngOnInit(): void {
  }

}
